import { useEnv, useTrackingSite } from "@/contexts/cdpConfig";
import { useEffect } from "react";
import { useTrackingAvDistributionType, useTrackingDatas, useTrackingEventsDatas, } from "./useTracking";
import { IS_SERVER } from "@/constants";
import { useConfirmationPage } from "@/contexts/confirmPage";
import { getUrlPath } from "@/utils";
import { useTrackingEvent } from "./useTrackingEvent";
import { useTrackingViewBase } from "./useTrackingViewBase";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useAuthenticationTracking } from "@/hooks/tracking/useAuthenticationTracking";
import { useAuthentication } from "@aviv-unified-frontend/runtime/authentication";
export const useTrackingView = () => {
    const { state } = useAuthentication();
    const { authTrackingData } = useAuthenticationTracking();
    const env = useEnv();
    const distributionType = useTrackingAvDistributionType();
    const site = useTrackingSite();
    const isPreviewMode = useIsPreviewMode();
    // @ts-ignore
    const eventData = Object.assign({ event: distributionType === "1"
            ? "classified_detail_view_rent"
            : "classified_detail_view_buy" }, useTrackingEventsDatas({
        displayMedium: true,
    }));
    const rentBuyViewTrackingEvent = useTrackingEvent(eventData);
    const { showConfirm } = useConfirmationPage();
    const av_pagetitle = showConfirm
        ? "classified_detail_lead_confirmation"
        : "classified_detail";
    const viewProps = Object.assign(Object.assign({}, useTrackingDatas()), { av_environment: env, av_user: authTrackingData, av_platform: "web", av_url_path: getUrlPath(), av_site: site, av_pagetitle });
    // view object is subject to change so it's not listed as dep (to avoid sending the event twice)
    const view = useTrackingViewBase(viewProps);
    // ThorEvent object is subject to change (so it's not listed as dep)
    useEffect(() => {
        if (!IS_SERVER && state !== "pending" && !isPreviewMode) {
            view();
            if (!showConfirm)
                rentBuyViewTrackingEvent();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [IS_SERVER, state]);
};
